import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT_QUERY = '(max-width: 639px)';

// Tracks whether the viewport is at or below the Tailwind `sm:` breakpoint
// (639px). SSR-guarded and subscribes to `matchMedia` changes so components
// re-render on resize (e.g. rotating a device or resizing a desktop window).
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(MOBILE_BREAKPOINT_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(MOBILE_BREAKPOINT_QUERY);
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
};

export default useIsMobile;
